<template>
  <div>
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <a-form
      v-else
      ref="inviteForm"
      layout="inline"
      :form="form"
      class="form"
      @submit.prevent="submitHandle"
    >
      <div class="reception-info">
        <h2 class="title">
          <!-- 接待信息 -->
          {{ $t('message[1759]') }}
        </h2>
        <div class="childs">
          <ReceiveItem
            v-if="receptionDatas && receptionDatas.child && receptionDatas.child[0]"
            :item-data="receptionDatas.child[0]"
            class="clearfix"
            @change="changeReception"
          />
        </div>
      </div>
      <div class="form-info">
        <h2 class="title">
          <!-- 来源信息 -->
          {{ $t('message[1760]') }}
        </h2>
        <draggable
          v-if="datas.length"
          v-model="listDatas"
        >
          <div
            v-for="(item,index) in listDatas"
            :key="index"
          >
            <item
              :data-info="item"
              :data-index="index"
              :form="form"
            />
          </div>
        </draggable>
        <div>
          <add-layout-form type="add" />
        </div>
      </div>
      <!-- <a-button
        type="primary"
        html-type="submit"
      >
        保存
      </a-button> -->
      <div class="footer-wrap">
        <div
          ref="footer"
          class="footer"
          :class="{'ani':isShowBtn}"
        >
          <a-button
            type="primary"
            html-type="submit"
            :disabled="isBtnDisable"
            :loading="submitting"
          >
            {{ $t('message["21"]') }}
          </a-button>
          <!-- <a-button @click="handleCancel">
            取消
          </a-button> -->
          <span class="sub-tip">{{ $t('message["22"]') }}？</span>
        </div>
      </div>
    </a-form>
  </div>
</template>
<script>
import Item from './item/Item'
import AddLayoutForm from './AddLayoutForm'
import ReceiveItem from './item/ReceiveItem'
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  components: {
    Item,
    ReceiveItem,
    AddLayoutForm
  },
  data () {
    return {
      isShowBtn: false,
      counter: 1,
      submitting: false,
      allDatas: {
        from: [],
        reception: {}
      }
    }
  },
  provide () {
    return {
      myForm: this
    }
  },
  computed: {
    ...mapState('config/referrer', ['receptionDatas', 'datas', 'datasReady', 'isBtnDisable']),
    listDatas: {
      set (val) {
        this.setDatas(val)
      },
      get () {
        return this.datas
      }
    }
  },
  watch: {
    datasReady (val) {
      if (val) {
        this.setFooterStyle()
      }
    },
    datas: {
      handler (val) {
        if (!val) return
        this.counter++
      },
      deep: true
    },
    counter (val) {
      if (this.counter > 2) {
        this.isShowBtn = true
        this.setFooterStyle()
      }
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    this.setFooterStyle()
    window.addEventListener('resize', this.setFooterStyle)
    document.addEventListener('scroll', this.setFooterStyle)
  },
  async mounted () {
    // 获取接待信息
    const chain = await this.fetchReferrerDatas()
    chain.params({ type: 1 })
      .onSuccess(() => {
        document.title = this.$t('message["1371"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
      })
      .fetch()

    // 获取来源信息
    let chain2 = await this.fetchReceptionDatas({ type: 9 })
    chain2.onSuccess(res => {
      this.allDatas.reception = this.receptionDatas
    })
  },
  methods: {
    ...mapMutations('config/referrer', ['setDatas']),
    ...mapActions('config/referrer', [
      'fetchReferrerDatas',
      'fetchReceptionDatas',
      'subReferrer',
      'removeClick'
    ]),
    changeReception (item) {
      this.counter++

      this.delTree(item.options)

      this.receptionDatas.child[0] = item
      this.allDatas.reception = this.receptionDatas
    },

    submitHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.deleteId(this.datas)
          this.submitting = true
          this.allDatas.from = this.datas

          const chain = await this.subReferrer()
          chain.params(this.allDatas)
            .onSuccess(async () => {
              this.removeClick()
              this.$message.success(this.$t('message["23"]') + '！')
              setTimeout(() => {
                location.reload()
              }, 1000)
            })
            .onNetSuccess((res) => {
              this.submitting = false
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    deleteId (arr) {
      arr.forEach((item, index) => {
        if (item._id) {
          delete item._id
        }
        if (item.child && item.child.length) {
          this.deleteId(item.child)
        }
      })
    },
    delTree (arr) {
      arr.forEach((item, index) => {
        delete item.title
        delete item.scopedSlots
        delete item.key
        delete item.addShow
        if (item._id) {
          delete item._id
        }
        if (item.options && item.options.length) {
          item.options.forEach(o => {
            if (o._id) {
              delete o._id
            }
          })
        }
        if (item.children && item.children.length) {
          this.delTree(item.children)
        }
      })
    },
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log(getScrollTop(), $footer.parentNode, $footer.parentNode.offsetTop)
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        // console.log(sectionWidth, pageWidth, $footer.parentNode.offsetLeft)
        if ($footer.parentNode.offsetTop - this.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left = pageWidth <= sectionWidth ? $footer.parentNode.offsetLeft + 1 + 'px' : $footer.parentNode.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reception-info {
  padding: 16px 0 40px;
  .childs {
    padding-top: 24px;
    border-top: solid 1px #ebebeb;
  }
}
h2.title {
  height: 32px;
  line-height: 32px;
  font-size: 24px;
  font-weight: 600;
}
.footer-wrap {
    height: 64px;
    margin-top: 40px;
  }
  .footer {
    position: fixed;
    bottom: -89px;
    left: 0;
    z-index: 999;
    height: 64px;
    margin-left: -40px;
    padding: 16px 80px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    transition: bottom 0.5s linear;
    .ant-btn {
      margin-right: 0 ;
    }
    span.sub-tip {
      color: #b3b3b3;
      margin-left: 10px;
    }
   opacity: 0;
  }
  .ani {
    bottom: 0;
    opacity: 1;
  }
</style>
